import { createFileRoute, redirect } from "@tanstack/react-router";
import { meQuery } from "../lib/session.ts";
import { SignInPage } from "../screens/sign-in/SignInPage.tsx";

/** Only paths on this address: never another site, never `//host`. */
function safeNext(value: unknown): string | undefined {
  return typeof value === "string" &&
    value.startsWith("/") &&
    !value.startsWith("//") &&
    !value.startsWith("/\\")
    ? value
    : undefined;
}

export const Route = createFileRoute("/sign-in")({
  validateSearch: (search: Record<string, unknown>): { next?: string } => {
    const next = safeNext(search.next);
    return next ? { next } : {};
  },
  beforeLoad: async ({ context, search }) => {
    const me = await context.queryClient.fetchQuery(meQuery).catch(() => null);
    if (me?.company) throw redirect({ href: search.next ?? "/" });
  },
  component: SignInPage,
});
